import { Crm4DealDetail } from "@/components/crm-demos/crm-4-deal-detail"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-4")({
  component: Crm4Page,
  head: () => ({ meta: [{ title: "CRM 4 · Deal Detail" }] }),
});

function Crm4Page() {
  return <Crm4DealDetail />
}
